"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = require("styled-components");
var utilts_1 = require("./utilts");
var Icon = function (_a) {
    var name = _a.name, _b = _a.size, size = _b === void 0 ? 'm' : _b, testId = _a.testId;
    var brandName = (0, styled_components_1.useTheme)().name;
    return ((0, jsx_runtime_1.jsx)("span", { className: "icon-".concat(brandName, "-").concat(name), style: {
            fontSize: (0, utilts_1.getIconFontSize)(size),
        }, "data-testid": testId }));
};
exports.default = Icon;
